import BranchSelect from './BranchSelect'
export default BranchSelect


// WEBPACK FOOTER //
// ./src/modules/BranchSelect/index.js